import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { MenuServices } from "../../../services";
import { SeparatorServices } from "../../../../services/separators";

/**
 * Generated class for the MenuPageCustomizeSeparatorsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-menu-page-customize-separators',
    templateUrl: 'menu-page-customize-separators.html',
})
export class MenuPageCustomizeSeparatorsPage {
    menu_uid: any;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public menuServices: MenuServices,
        public separatorServices: SeparatorServices) {
        this.menu_uid = this.navParams.get('menu_uid');
    }

    ionViewWillEnter() {
        this.separatorServices.getList();
    }

    update(value) {
        this.menuServices.afs.collection('menus').doc(this.menu_uid).update({
            'separator': value,
        }).then(() => {
            this.navCtrl.pop();
        });
    }

}



// WEBPACK FOOTER //
// ./src/pages/menu/menu-view/menu-partial-customize-options/menu-page-customize-separators/menu-page-customize-separators.ts